import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import utilsService from '@/api/utilsService.vue';
import App from './App.vue';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-toastification/dist/index.css';
import Toast from 'vue-toastification';
import Swal from 'sweetalert2';
import router from './routes/router';
import translator from '@/util/language.js'; 
import store from './store'; // <<--- IMPORTANTE: importa el store de Vuex
import permisosMixin from '@/mixins/permisos';

const _urlLang = new URLSearchParams(window.location.search).get('lang');
if (_urlLang && ['es', 'en'].includes(_urlLang)) {
  translator.setLanguage(_urlLang);
}

window.Swal = Swal;
Vue.prototype.$swal = function(...args) {
  return Swal.fire(...args);
};
Vue.use(DashboardPlugin);
Vue.use(Toast);
Vue.prototype.$t = translator.t.bind(translator);
Vue.prototype.$setLanguage = translator.setLanguage.bind(translator);
Vue.prototype.$getLanguage = translator.getLanguage.bind(translator);
Vue.prototype.$utilsService = utilsService;
Vue.prototype.$globalMethods = {};

// Expone `puedeEscribir` / `esSoloLectura` en todos los componentes
Vue.mixin(permisosMixin);

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store // <<--- IMPORTANTE: registra el store en la instancia Vue
});